module.exports = __webpack_public_path__ + "img/explain.827e62bf.png";